function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
import config from 'react-global-configuration';
import Immutable from 'immutable';
import { referenceLoadingStart, referenceLoadingDone } from '../../UI/ReferenceLoading';
function fromJSOrdered(js) {
  return _typeof(js) !== 'object' || js === null ? js : Array.isArray(js) ? Immutable.Seq(js).map(fromJSOrdered).toList() : Immutable.Seq(js).map(fromJSOrdered).toOrderedMap();
}
export var webformGet = function webformGet(webformId) {
  return function (dispatch, getState) {
    dispatch(referenceLoadingStart());
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'webform']) || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);

    // Get webform info.
    fetch("".concat(PATH, "/webform_rest/").concat(webformId, "/info?_format=json"), {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(webformGetInfoLoaded(webformId, response));
    });

    // Get Webform fields.
    fetch("".concat(PATH, "/webform_rest/").concat(webformId, "/fields?_format=json"), {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return fromJSOrdered(json);
    }).then(function (response) {
      dispatch(webformGetLoaded(webformId, response));
      dispatch(referenceLoadingDone());
    }).catch(function () {
      dispatch(referenceLoadingDone());
    });
  };
};
export var WEBFORM_GET_LOADED = 'WEBFORM_GET_LOADED';
export function webformGetLoaded(webformId, data) {
  return {
    type: WEBFORM_GET_LOADED,
    webform_id: webformId,
    data: data
  };
}
export var WEBFORM_GET_INFO_LOADED = 'WEBFORM_GET_INFO_LOADED';
export function webformGetInfoLoaded(webformId, data) {
  return {
    type: WEBFORM_GET_INFO_LOADED,
    webform_id: webformId,
    data: data
  };
}